const faqs = [
  {
    q: '土豪漫画网有哪些漫画分类？',
    a: '我们的漫画分类涵盖韩漫推荐、日漫大全和国漫排行榜三大核心板块，并细分热血战斗、甜蜜恋爱、悬疑推理、奇幻冒险等多种类型。无论你喜欢哪种风格，都能通过精准的漫画分类快速找到心仪作品。',
  },
  {
    q: '网站上的漫画多久更新一次？',
    a: '我们坚持每日同步更新最新章节，确保韩漫推荐、日漫大全和国漫排行榜中的热门作品第一时间上架。通常热门连载漫画在官方更新后24小时内即可在本站阅读，更新速度快、品质有保障。',
  },
  {
    q: '如何找到适合自己口味的漫画？',
    a: '你可以通过首页的漫画索引按分类浏览，也可以查看漫画热度排行榜了解大家都在追的热门作品。焦点专题板块定期推出精选合集，从不同角度帮你发现好看的漫画。如果你喜欢特定类型，直接使用分类漫画导航即可。',
  },
  {
    q: '土豪漫画网是否需要注册或付费？',
    a: '本站为漫画爱好者提供免费的漫画信息浏览与推荐服务，无需注册即可浏览全部漫画分类、排行榜和专题内容。我们致力于打造一个开放、友好的漫画发现平台，让每一位读者都能轻松找到好看的漫画。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">常见问答</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            关于<strong>土豪漫画网</strong>使用的常见问题，帮你快速了解我们的服务
          </p>
        </div>

        <div className="max-w-[800px] mx-auto space-y-3 md:space-y-4">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-background-50 border border-background-200/60 rounded-xl overflow-hidden">
              <div className="p-5 md:p-6">
                <h3 className="font-serif font-semibold text-sm md:text-base text-foreground-900 mb-3 flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-500 flex items-center justify-center text-xs font-bold mt-0.5">Q</span>
                  <span>{faq.q}</span>
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed flex items-start gap-3 pl-9">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-accent-100 text-accent-500 flex items-center justify-center text-xs font-bold mt-0.5">A</span>
                  <span>{faq.a}</span>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}